// extracted by mini-css-extract-plugin
export default {"table":"w7xzKwf9WmGV7r4lRxk2","opened":"OUzfwNBTmojQGy4hfC1g","closed":"jLECBRzNBDxIw92FHl26","selectTitle":"ltL0JR8_OcahyagvnWev","permission":"IQr6b9skQO6fX9o1TvI4"};